import { gql, useLazyQuery } from "@apollo/client";
import { CouponScopeEnum, CouponStatusEnum } from "../constants/enum";

const GET_COUPON_QUERY = gql`
  query getCoupon($input: GetCouponInput!) {
    getCoupon(input: $input) {
      ok
      err
      coupon {
        id
        name
        code
        status
        scope
        linkService {
          id
          name
        }
        corporation {
          id
          name
        }
        discountPrice
        usageLimit
        userUsageLimit
        validFrom
        validUntil
        createdAt
      }
    }
  }
`;

export interface GetCouponInput {
  couponId: number;
}

export interface GetCouponQueryVariables {
  input: GetCouponInput;
}

export interface GetCouponQuery {
  getCoupon: {
    ok: boolean;
    err: string;
    coupon: {
      id: number;
      name: string;
      code: string;
      status: CouponStatusEnum;
      scope: CouponScopeEnum;
      linkService: {
        id: number;
        name: string;
      };
      corporation: {
        id: number;
        name: string;
      };
      discountPrice: number;
      usageLimit: number;
      userUsageLimit: number;
      validFrom: string;
      validUntil: string;
      createdAt: string;
    };
  };
}

export const useGetCoupon = (onCompleted?: (data: GetCouponQuery) => void) => {
  return useLazyQuery<GetCouponQuery, GetCouponQueryVariables>(
    GET_COUPON_QUERY,
    {
      onCompleted,
    }
  );
};
